// fonts
require('typeface-open-sans')

var $ = require("jquery");
window.$ = window.jQuery = $;
require('slick-carousel');
const Parallax = require('jquery-parallax.js')
require('./_resize.js');
import swal from 'sweetalert';
import Cookies from 'js-cookie'

// custom scripts
$(document).ready(function() {
    $('form').on('submit', function(e) {
        e.preventDefault()
        var data = $(this).serialize(),
            form = $(this);
        $.post('mailer/main.php', data)
            .done(function( data ) {
                swal('Email verschickt',data,'success');
                form.trigger('reset');
            })
            .fail(function(data) {
                swal('Fehler',data.responseText,'error');
            });
    });
});

$(document).ready(function () {
    $('.parallax-window').parallax({imageSrc: 'img/Wartezimmer3.jpg'});

    var nav = $('nav');

    var navMinimizer = function () {
        if(nav.offset().top > 0 || $(window).width() < 1620){
            nav.addClass('minimized');
        } else {
            nav.removeClass('minimized');
        }
    };

    $(window).scroll(function () {
      navMinimizer();
    });
    $(window).resize(function () {
        navMinimizer();
    });
    navMinimizer();

    var words = $('.words li');
    var content = $('.content li');
    words.click(function () {
       var index = $(this).index();
       if($(window).width() < 1280){
           swal({title:$(this).html(),text: content.eq(index).html()});
       } else {
       content.fadeOut('fast',function () {
           setTimeout(function () {
               content.eq(index).css('padding-top',words.eq(index).position().top - 90);
               content.eq(index).fadeIn('fast');
           },250);
       });
       }
    });

    $('.pochert').click(function () {
        $('html,body').animate({scrollTop: $('.text-img').offset().top});
        $('.burger').removeClass('active');
        navItems.removeClass('active');
        $('nav').removeClass('magic');
    });
    $('.leistungen').click(function () {
        $('html,body').animate({scrollTop: $('.dictionary').offset().top});
                $('.burger').removeClass('active');
        navItems.removeClass('active');
        $('nav').removeClass('magic');
    });
    $('.impressionen').click(function () {
        $('html,body').animate({scrollTop: $('.gallery').offset().top});
                $('.burger').removeClass('active');
        navItems.removeClass('active');
        $('nav').removeClass('magic');
    });
    $('.kontakt').click(function () {
        $('html,body').animate({scrollTop: $('.contact').offset().top});
                $('.burger').removeClass('active');
        navItems.removeClass('active');
        $('nav').removeClass('magic');
    });


    //$('#map').append('<div style="width: 100%"><iframe width="400" height="195" src="https://maps.google.com/maps?width=100%&amp;height=195&amp;hl=en&amp;q=Ungererstrasse%20118%2C%20Muenchen+(Praxis%20Dr.%20Maximilian%20Pochert)&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=A&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div><br />');
    function showMap(checkCookie) {
        if(checkCookie) {
            if(Cookies.get('show_map') != 'true') {
                return;
            }
        }

        var src = $('#map').data('src');
        $('.map-no-cookie').hide();
        $('#map').append('<div style="width: 100%"><iframe width="400" height="195" src="'+ src +'" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div><br />');
        Cookies.set('show_map', 'true', { expires: 31 });
    }

    $('#embed-link').on('click', function() {
        showMap(false);
    });

    showMap(true);

    $('.gallery .inner-wrapper').slick({
        autoplay: true,
        infinite: true,
        arrows: true,
        //mobileFirst: true,
        variableWidth: true,
        centerMode: true
    });

    var navItems = $('.nav-items');
    $('.burger').click(function () {
        if(!navItems.hasClass('active')){
            $(this).addClass('active');
            navItems.addClass('active');
            $('nav').addClass('magic');
        } else {
            $(this).removeClass('active');
            navItems.removeClass('active');
            $('nav').removeClass('magic');
        }
    });

    $('.home').click(function () {
        $('html,body').animate({scrollTop: 0});
    });
});



//////////////////
// WEBPACK FOOTER
// ./js/js.js
// module id = 4
// module chunks = 0